<template>
  <div class="wrapper">
    <div class="container">
      <md-card class="customCard navbar-margin">
        <md-card-content>
          <div class="tim-typo">
            <h2 class="title">Produkte</h2> 
            <p>Wir bieten Ihnen eine Vielfalt an Produkten. Sicherlich ist auch das passende Produkt für Sie dabei. <br> 
              Nehmen Sie Kontakt mit uns auf, damit wir gemeinsam Ihre Ideen und Vorstellungen planen und ausführen können.</p>
            <p>Weitere Bilder finden Sie in unserer <a style="color: blue; font-weight: bold;" target="_blank" rel="noopener noreferrer" href="http://galerie.leibhammer-rietz.de/kristall">Galerie.</a></p>
          </div>
          <div class="gallery">
            <div class="gallery-panel"
              v-for="product in products"
              :key="product.id">
                <router-link :to="`/produkte/${product.family}`">
                  <mdb-view  class="zoom rounded hoverable z-depth-1-half" :src="thumbUrl(product.filename)">
                    <mdb-mask class="flex-center">
                      <p class="panel-titel"> {{product.caption}} </p>
                    </mdb-mask>
                  </mdb-view>
                </router-link>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import products from '@/components/products.json';
import { mdbView, mdbMask } from "mdbvue";

export default {
  name: 'Gallery',
  data() {
    return {
      products,
    };
  },
  methods: {
    thumbUrl(filename) {
      return require(`../assets/prod_images/_thumbnails/${filename}`);
    },
    validator(variable) {
      if (variable != null) {
        return variable;
      } 
    },
    onResponsiveInverted() {
      if (window.innerWidth < 600) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  },
  components: {
    mdbView,
    mdbMask
  }
};
</script>
